<section class="upload-step">
  <h2 class="upload-step__title">Carica certificati</h2>
  <p class="upload-step__description">
    Aggiungi i certificati dei materiali in formato PDF.
  </p>

  <input
    #certificateFileInput
    type="file"
    accept=".pdf"
    hidden
    (change)="onCertificateSelected($event)"
  />

  <button
    type="button"
    class="upload-step__button"
    (click)="uploadCertificate()"
  >
    <i class="bx bx-plus-circle"></i>
    <span>AGGIUNGI</span>
  </button>

  @if (uploadedFileName) {
    <p class="upload-step__file-name">
      PDF caricato: {{ uploadedFileName }}
    </p>
  }
</section>
